import React from 'react';
import { Button as StrapButton } from 'reactstrap';
import './styles.css';

function Button(props) {
  return (
    <StrapButton className={'section-button'} {...props}>
      {props.children}
    </StrapButton>
  );
}

export default Button;
